import { useGateValue } from '@statsig/react-bindings';

export function useTutorialEnabled(): boolean {
  return useGateValue('enable_tutorials');
}
